module.exports = __webpack_public_path__ + "fonts/fa-brands-400.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.ttf
// module id = 47
// module chunks = 0